module.exports = __webpack_public_path__ + "media/images/admin/icons/disc-2ff64a52f8a9e6470c02f3a8231dac8d.svg";